<div>
  <v-menu
    location="bottom right"
    :width="340"
    :max-height="600"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        icon
        flat
        size="40"
        @click="onClickPushMessagesBell"
      >
        <v-icon
          :color="unreadWebpushMessages ? 'blue' : 'grey lighten-1'"
          size="34"
        >
          mdi-bell
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title> {{ $t('app.webpush.pushmessages') }} </v-card-title>
      <v-divider></v-divider>
      <v-list flat class="push-message-list-left-rim">
        <template v-for="date in dates" :key="date">
          <v-sheet
            rounded
            color="primary"
            class="text-center font-weight-medium py-1"
          >
            {{ $filters.formatDateWithLocale(date, $i18n.locale) }}
          </v-sheet>
          <template
            v-for="(item, index) in getWebPushMessagesAtDate(date)"
            :key="item.id"
          >
            <v-list-item>
              <div class="d-flex justify-space-between">
                <v-list-item-title class="mt-1 d-flex w-100">
                  <v-chip
                    v-if="!item.read"
                    color="blue"
                    text-color="white"
                    size="small"
                    class="mr-1 px-2"
                  >
                    {{ $t('app.new') }}
                  </v-chip>
                  <div
                    class="text-wrap text-body-medium text-sm-body-large font-weight-medium heading-row-gap w-75"
                  >
                    {{ item.title }}
                  </div>
                </v-list-item-title>
                <div class="text-body-small pt-1">
                  {{ getLocalTimeOfMessage(item) }}
                </div>
              </div>
              <expandable-element
                :baseHeight="80"
                class="text-body-small text-sm-body-medium mt-2"
                :class="{ 'text-row-gap': mobileXs }"
              >
                {{ item.text }}
              </expandable-element>
            </v-list-item>
            <v-divider class="my-2"></v-divider>
          </template>
        </template>
        <div class="d-flex justify-space-between align-center">
          <v-btn
            icon
            flat
            :disabled="webPushMessagesPage <= 1"
            @click="decreaseWebPushMessagesPage"
          >
            <v-icon
              size="large"
              :color="webPushMessagesPage <= 1 ? 'grey' : 'blue'"
            >
              mdi-arrow-left-bold-circle-outline
            </v-icon>
          </v-btn>
          <span class="text-body-large">
            {{ $t('app.webpush.page', {page: webPushMessagesPage, maxPage:
            webPushMessagesMaxPage}) }}
          </span>
          <v-btn
            icon
            flat
            :disabled="webPushMessagesPage >= webPushMessagesMaxPage"
            @click="increaseWebPushMessagesPage"
          >
            <v-icon
              size="large"
              :color="webPushMessagesPage >= webPushMessagesMaxPage ? 'grey' : 'blue'"
            >
              mdi-arrow-right-bold-circle-outline
            </v-icon>
          </v-btn>
        </div>
      </v-list>
    </v-card>
  </v-menu>
</div>
